import { map } from "rxjs";
import { GET, POST } from "../../../../module/services/fetch";

export const getPaginationTableConfigurations = (payload: any) => {
  const { body, sortBy } = payload;
  return POST(
    `admin/recertification/configurations/find${
      sortBy && sortBy.length > 0
        ? `?sortField=${
            sortBy[0].id === "createDate" ? "creationDate" : sortBy[0].id
          }&sortOrder=${sortBy[0].desc ? "desc" : "asc"}`
        : ""
    }`,
    body
  ).pipe(map((response: any) => response));
};

export const getConfigurationEnrichment = (configurationId: string) =>
  GET(`admin/recertification/configuration/${configurationId}/enrichment`).pipe(
    map((response: any) => response)
  );
